import { useEffect, useLayoutEffect, useState } from 'react'

export const useWindowSize = () => {
  const [size, setSize] = useState([0, 0])

  useIsomorphicLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight])
    }

    window.addEventListener('resize', updateSize)
    updateSize()
    return () => window.removeEventListener('resize', updateSize)
  }, [])

  return size
}

// prevents useLayoutEffect from throwing an error when used with SSR by conditionally using useEffect if on server or not
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
